
document.addEventListener("DOMContentLoaded", function () {

  const popup = document.getElementById("supplement-popup");
  const openBtn = document.querySelector(".js-open-supplement-popup");
  const closeBtn = popup.querySelector(".supplement-popup__close");
  const overlay = popup.querySelector(".supplement-popup__overlay");

  const tabs = popup.querySelectorAll(".supplement-tab");
  const contents = popup.querySelectorAll(".supplement-tab-content");

  // Open popup
  if (openBtn) {
    openBtn.addEventListener("click", function () {
      popup.classList.add("active");

      // Reset to Tab 1 on open
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      tabs[0].classList.add("active");
      contents[0].classList.add("active");
    });
  }

  // Close popup
  closeBtn.addEventListener("click", () => popup.classList.remove("active"));
  overlay.addEventListener("click", () => popup.classList.remove("active"));

  // Tabs switch
  tabs.forEach(tab => {
    tab.addEventListener("click", function () {
      const target = this.dataset.tab;

      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      this.classList.add("active");
      popup.querySelector("#" + target).classList.add("active");
    });
  });

});
